/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPharmacistPasswordRequestBodyTypename = "PutPharmacistPasswordRequestBody" as const;

/**
 *
 * @export
 * @interface PutPharmacistPasswordRequestBody
 */
export interface PutPharmacistPasswordRequestBody {
  /**
   *
   * @type {string}
   * @memberof PutPharmacistPasswordRequestBody
   */
  password: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPharmacistPasswordRequestBody
   */
  readonly __typename?: string;
}

export function PutPharmacistPasswordRequestBodyFromJSON(json: any): PutPharmacistPasswordRequestBody {
  return PutPharmacistPasswordRequestBodyFromJSONTyped(json, false);
}

export function PutPharmacistPasswordRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPharmacistPasswordRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPharmacistPasswordRequestBodyTypename,

    password: json["password"],
  };
}

export function PutPharmacistPasswordRequestBodyToJSON(object?: PutPharmacistPasswordRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    password: value.password,
  };
}
